import {
  MultiSelect,
  type MultiSelectChangeEvent,
} from "primereact/multiselect";

export type FinanceSelectOption<T extends number | string> = {
  label: string;
  value: T;
};

type FinanceMultiSelectProps<T extends number | string> = {
  disabled?: boolean;
  onChange: (value: T[]) => void;
  options: FinanceSelectOption<T>[];
  placeholder: string;
  value: T[];
};

export default function FinanceMultiSelect<T extends number | string>({
  disabled = false,
  onChange,
  options,
  placeholder,
  value,
}: FinanceMultiSelectProps<T>) {
  return (
    <MultiSelect
      className="w-full"
      disabled={disabled}
      display="chip"
      filter
      maxSelectedLabels={2}
      onChange={(event: MultiSelectChangeEvent) =>
        onChange((event.value ?? []) as T[])
      }
      options={options}
      panelClassName="finance-multiselect-panel text-sm"
      placeholder={placeholder}
      pt={{
        header: { className: "!px-3 !py-1.5" },
        item: { className: "!px-3 !py-1.5 text-sm" },
        list: { className: "!py-1" },
      }}
      selectedItemsLabel="{0} selected"
      showClear
      value={value}
    />
  );
}
